import React from "react";
import DynamicTable from "../../widgets/dynamicTable/DynamicTable.jsx";
import HelperMetiers360 from "../../../services/HelpersMetiers360.js";
import PropTypes from 'prop-types';

import '../preparatoryOrders/PreparatoryOrderTableComponent.scss';
import { useModal } from "../../../hooks/useModal.jsx";

import { useStoreActions } from "easy-peasy";
import LoaderAccessPingsTableComponent from "./LoaderAccessPingsTableComponent.jsx";
import LoaderAccessPingsStatsTableComponent from "./LoaderAccessPingsStatsTableComponent.jsx";
import CustomTabsWithParams from "../../widgets/customTabs/CustomTabsWithParams.jsx";

const LoaderAccessesTableComponent = ({ loaderAccesses }) => {

    const { fetchOneLoaderAccessPings } = useStoreActions(actions => actions.orders);
  
    const { modalComponent, setModalShow, modalData, setModalData } = useModal();

    const sortType = loaderAccesses?.length > 0
        && [

            {
                value : 'name', label : 'Prestataire',
                test : HelperMetiers360.isArrayContainsValue(loaderAccesses, "name"),
                method : (a, b) => HelperMetiers360.localeCompareWithNullable(a.name, b.name),
                display: (loaderAccess) => loaderAccess.name ?? '-'
            },
            {
                value : 'active', label : 'Actif',
                test : HelperMetiers360.isArrayContainsValue(loaderAccesses, "active"),
                method: (a, b) => HelperMetiers360.localeCompareWithNullable(a.active, b.active),
                display: (loaderAccess) => loaderAccess.active ? "Oui" : "Non"
            },
            {
                value : 'pingsCount', label : 'Actions',
                test : HelperMetiers360.isArrayContainsValue(loaderAccesses, "pingsCount"),
                method: (a, b) => HelperMetiers360.localeCompareWithNullable(a.pingsCount, b.pingsCount),
                display: (loaderAccess) => loaderAccess.pingsCount
            },
            {
                value : 'lastPingDateTime', label : 'Dernière connexion',
                test : HelperMetiers360.isArrayContainsValue(loaderAccesses, "lastPingDateTime"),
                method: (a, b) => HelperMetiers360.dateCompareWithNullableDescending(a.lastPingDateTime, b.lastPingDateTime),
                display: (loaderAccess) => loaderAccess?.lastPingDateTime ? HelperMetiers360.getdisplayDateType(loaderAccess.lastPingDateTime) : '-'
            }
        ];



    
    const showPings = (uniqueId) => {
   
        const result = fetchOneLoaderAccessPings(uniqueId);

        result.then((loaderAccess) => {
            const contentTabs = [
                {
                    eventKey: "statPings",
                    title: "Statistiques d'actions",
                    mountOnEnter: true,
                    unmountOnExit: undefined,
                    content: <LoaderAccessPingsStatsTableComponent loaderAccessPings={loaderAccess.pings} />
                },
                {
                    eventKey: "allPings",
                    title: "Toutes les actions",
                    mountOnEnter: true,
                    unmountOnExit: undefined,
                    content: <LoaderAccessPingsTableComponent loaderAccessPings={loaderAccess.pings} />
                }
            ]

            setModalData({
                ...modalData,
                header: <>{loaderAccess.loaderAccessName}</>,
                content: loaderAccess.pings.length > 0
                    ? <CustomTabsWithParams
                        contentTabs={contentTabs}
                        defaultActiveTabId='statPings'
                        id="loader-access-pings-tab"
                        withParams={false}
                    />
                    : <em>Aucune action enregistrée</em>,
                footer: null,
                size: 'lg'
            });
            setModalShow(true);
        });
    }

    return sortType && <>
        <DynamicTable 
            contentTable={loaderAccesses}
            contentSort={sortType}
            valueInitSort="pingsCount"
            index='uniqueId'
            tableName="loaderAccessesTable"
            handleClick={showPings}
            filename="loader"
        />
            {modalComponent}
    </>;
};

LoaderAccessesTableComponent.propTypes = {
    loaderAccesses: PropTypes.array.isRequired,
};

export default LoaderAccessesTableComponent;